export default __webpack_public_path__ + "static/media/project.3fb2609f.png";